import ImpactWindowsSection from '../sections/ImpactWindowsSection'

const ImpactWindowsPage = () => <ImpactWindowsSection />

export default ImpactWindowsPage
